<template>
    <div style="margin-top: 60px">
        <h3>System Notification Emails</h3>
        <p>Adjust email addresses for system notifications here. You can set one email address per notification type.</p>

        <div class="table-responsive VueTables VueTables--server snappy-table">
            <table id="systemNotificationsEmails" class="VueTables__table table table-striped table-bordered table-hover" style="overflow: hidden;">
                <thead>
                    <tr>
                        <th tabindex="0" class="email" style="position: relative;">
                            <span title="" class="VueTables__heading">Email Address</span>
                            <div class="resize-handle" style="top: 0px; right: 0px; width: 5px; position: absolute; cursor: col-resize; user-select: none; height: 101px;"></div>
                        </th>
                        <th tabindex="0" class="email" style="position: relative;">
                            <span title="" class="VueTables__heading">Type</span>
                            <div class="resize-handle" style="top: 0px; right: 0px; width: 5px; position: absolute; cursor: col-resize; user-select: none; height: 101px;"></div>
                        </th>
                        <th tabindex="0" class="email" style="position: relative;">
                          <span title="" class="VueTables__heading">Description</span>
                          <div class="resize-handle" style="top: 0px; right: 0px; width: 5px; position: absolute; cursor: col-resize; user-select: none; height: 101px;"></div>
                        </th>
                        <th tabindex="0" class="actions" style="position: relative;">
                            <span title="" class="VueTables__heading">Actions</span>
                            <div class="resize-handle" style="top: 0px; right: 0px; width: 5px; position: absolute; cursor: col-resize; user-select: none; height: 101px;"></div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                <tr v-if="processing">
                  <div class="table-loading-wrapper">
                    <div class="table-loading-backdrop" :style="loadingBackdropStyle">
                      <div class="table-loading-indicator"></div>
                    </div>
                  </div>
                </tr>
                <tr v-else-if="loading">
                    <td colspan="4" class="text-center">Loading...</td>
                </tr>
                <tr v-for="(setting, type) in system_emails" class="VueTables__row ">
                    <td tabindex="0" class="email">
                      <input type="text" class="form-control new_email_input" v-model="setting.email" :placeholder="default_email" />
                    </td>
                    <td>
                      <p class="small" v-text="setting.label" />
                    </td>
                    <td>
                      <p class="small" v-text="setting.description" />
                    </td>
                    <td tabindex="0" class="actions">
                      <button
                          :disabled="(!system_emails_state[type].email === !setting.email) || (system_emails_state[type].email === setting.email) || processing"
                          @click="onSave(type, setting.email)"
                          class="btn btn-success has-tooltip"
                          data-original-title="Delete"
                      ><i class="fas fa-fw fa-save"></i></button>
                    </td>
                </tr>
              </tbody>
            </table>
      </div>
    </div>
</template>

<script>
import SnappyTable from '../../../components/SnappyTable';
import axios from "axios";
import swal from "sweetalert2";
import * as Sentry from "@sentry/vue";

export default {
    name: 'system-notifications-emails',
    data() {
        return {
            default_email: null,
            system_emails: {},
            system_emails_state: {},
            type: null,
            processing: false,
            loading: true,
            loadingBackdropStyle: null,
        };
    },
    components: {
        SnappyTable
    },
    mounted() {
        this.getEmails();
    },
    methods: {
        handleError(error) {
            const {data} = error.response || {};
            if (data && data.errors) {
                swal.fire({
                    title: 'UhOh!',
                    text: Object.values(data.errors).map(array => array.join(" ")).join(" "),
                    type: 'error',
                    confirmButtonText: 'Ok',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-lg btn-primary'
                });
            } else {
              Sentry.captureException(error);
            }
        },
        onSave(type, email) {
          return !email ? this.deleteEmail(type) : this.storeEmail(type, email)
        },
        deleteEmail(type) {
            this.recalculateLoadingBackdropDimensions();
            this.processing = true;
            axios.post('/api/?entity=vessel&action=deleteSystemNotification', { type })
                .then(() => this.system_emails_state[type].email = '')
                .catch(this.handleError)
                .finally(() => {
                  this.loading = false
                  this.processing = false
                });
        },
        getEmails() {
          Promise.all([
            axios.get('/api/?entity=vessel&action=getVessel')
                .then((response) => {
                  this.default_email = response.data.data.emails.data[0].email;
                })
                .catch(this.handleError),
            axios.post('/api/?entity=vessel&action=getSystemNotifications')
                .then((response) => {
                  this.system_emails = response.data.data;
                  this.system_emails_state = JSON.parse(JSON.stringify(this.system_emails));
                })
                .catch(this.handleError)
          ]).finally(() => {
            this.loading = false
            this.processing = false
          })
        },
        storeEmail(type, email) {
            this.recalculateLoadingBackdropDimensions();
            this.processing = true;

            const data = {
              type: type,
              value: email
            };

            axios.post('/api/?entity=vessel&action=updateSystemNotifications', data)
                .then(() => this.system_emails_state[type].email = email)
                .catch(this.handleError)
                .finally(() => {
                  this.loading = false
                  this.processing = false
                });
        },
        recalculateLoadingBackdropDimensions() {
            const tbody = document.querySelector(`#systemNotificationsEmails tbody`);
            if (tbody) {
                this.loadingBackdropStyle = {
                    height: `${tbody.clientHeight}px`,
                    width: `${tbody.clientWidth}px`
                };
            }
        },
    }
};
</script>

<style lang="scss">
.table-loading-wrapper {
  position: relative;
}

.table-loading-backdrop {
  background: rgba(#ffffff, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
}

.table-loading-indicator {
  background: center / 50px no-repeat url("/wp-content/themes/snappy-theme/assets/images/loading2.gif");
  width: 50px;
  height: 50px;
}
.modal {

    .modal-body {

        form > .form-group {
            margin: auto;
        }
    }
}
</style>
